module.exports = __webpack_public_path__ + "img/logo-white.27137cd5.svg";